/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, formatFecha, TablaFiltrable } from "../../shared";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";

const FILTROS = [
  { campo: "_colaboradorText", label: "Colaborador", labelPlural: "colaboradores" }
];
const SEARCH_FIELDS = ["_colaboradorText"];

// Facturas de colaboradores subidas y pendientes de pago. Al clickear una,
// lleva al detalle del colaborador para registrar el pago.
export default function PagosColaboradoresPendientes({ toast }) {
  const [facturas, setFacturas] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/destacados/facturascolaboradorespendientes",
      null,
      (respuesta) => {
        setFacturas(respuesta);
        setLoading(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar pagos a colaboradores",
          sticky: true
        });
        setLoading(false);
      }
    );
  }, [toast]);

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  if (!facturas || facturas.length === 0) {
    return null;
  }

  const datos = facturas.map((f) => ({
    ...f,
    _colaboradorText: `${f.auditor.nombre} ${f.auditor.apellido}`
  }));

  return (
    <Accordion
      activeIndex={null}
      css={{
        marginTop: "1em",
        "& .p-accordion-header-link": { color: "black" },
        "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
      }}
    >
      <AccordionTab header={`Pagos a colaboradores (${facturas.length})`}>
        <TablaFiltrable
          value={datos}
          filtros={FILTROS}
          searchFields={SEARCH_FIELDS}
          nombreArchivo="pagos_colaboradores_pendientes"
          onRowClick={(e) => {
            const url = `/proveedores/auditores/${e.data.auditor.id}?volver=/`;
            e.originalEvent.metaKey || e.originalEvent.ctrlKey
              ? window.open(url, "_blank")
              : navigate(url);
          }}
          size="small"
          emptyMessage="No hay pagos pendientes de colaboradores"
          css={{
            "& .p-datatable-tbody > tr": { cursor: "pointer" }
          }}
        >
          <Column header="Colaborador" field="_colaboradorText" />
          <Column
            header="Actividades"
            body={(f) => f._count?.pagos ?? 0}
            style={{ width: "8rem" }}
          />
          <Column
            header="Monto"
            body={(f) => `${f.moneda?.simbolo || ""} ${f.monto}`.trim()}
            style={{ width: "9rem", textAlign: "right" }}
            alignHeader="right"
          />
          <Column
            header="Fecha"
            body={(f) => formatFecha(f.fecha)}
            style={{ width: "8rem" }}
          />
        </TablaFiltrable>
      </AccordionTab>
    </Accordion>
  );
}
